export const CARESHEET_SETTINGS_RECEIVED = 'petdata/CARESHEET_SETTINGS_RECEIVED';
export const GET_CARESHEET_SETTINGS = 'petdata/GET_CARESHEET_SETTINGS';

export const AD_SELECTED = 'petdata/AD_SELECTED';
export const AD_DESELECTED = 'petdata/AD_DESELECTED';
export const AD_DELETED = 'petdata/AD_DELETED';

export const SAVE_INFO_SUCCESS = 'petdata/SAVE_INFO_SUCCESS';

export const CARESHEET_LIST_RECEIVED = 'petdata/CARESHEET_LIST_RECEIVED';
export const PET_TYPES_ADDED = 'petdata/caresheets/PET_TYPES_ADDED';

export const TOGGLE_SELECTED_PET_TYPE = 'petdata/caresheets/TOGGLE_SELECTED_PET_TYPE';

export const FILTER_CARESHEETS = 'petdata/FILTER_CARESHEETS';
export const CLEAR_SEARCH_RESULTS = 'petdata/caresheets/CLEAR_SEARCH_RESULTS';
export const CARESHEET_SEARCH_PHRASE = 'petdata/CARESHEET_SEARCH_PHRASE';

export const DOWNLOAD_CARE_SHEET = 'petdata/DOWNLOAD_CARE_SHEET';

export const SHOW_ERROR_MODAL = 'petdata/SHOW_ERROR_MODAL';


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/actionTypes.js
 **/